import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Restart"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M18.75 13.5C18.75 17.6421 15.3921 21 11.25 21C7.10786 21 3.75 17.6421 3.75 13.5C3.75 9.35786 7.10786 6 11.25 6H15.885L13.2 8.6925L14.25 9.75L18.75 5.25L14.25 0.75L13.2 1.8075L15.8925 4.5H11.25C6.27944 4.5 2.25 8.52944 2.25 13.5C2.25 18.4706 6.27944 22.5 11.25 22.5C16.2206 22.5 20.25 18.4706 20.25 13.5H18.75Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Restart.vue"]]);
